import React, { InputHTMLAttributes } from "react";
import { useField, useFormikContext } from "formik";
import { ReactComponent as ConfirmIcon } from "../../assets/icons/confirm.svg";
import { trim } from "../../utils/trim";
import { Tooltip as ReactTooltip } from "react-tooltip";

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  children?: React.ReactNode;
  name: string;
  label: string;
  link?: {
    label: string;
  };
}

const Checkbox: React.FC<CheckboxProps> = ({
  children,
  name,
  label,
  link,
  ...props
}) => {
  const { submitCount } = useFormikContext();
  const [field, meta, helpers] = useField(name);
  const showError = submitCount > 0 && Boolean(meta.error);

  return (
    <div
      className={trim(
        `checkbox ${!!field.value ? "checkbox--checked" : ""} ${
          showError ? "checkbox--error" : ""
        }`
      )}
    >
      <label className="checkbox_inner">
        <input
          className="checkbox_field"
          type="checkbox"
          {...field}
          {...props}
          checked={!!field.value}
          onChange={(event) => {
            helpers.setValue(event.target.checked, true);
            props.onChange?.(event);
          }}
        />

        {showError && (
          <ReactTooltip
            isOpen
            id={name}
            place="top"
            content={meta.error}
            style={{
              color: "#fb7070",
              fontWeight: 600,
              fontFamily: "Montserrat",
              backgroundColor: "#2f2f2f",
              pointerEvents: "none",
            }}
          />
        )}
        <div data-tooltip-id={name} className="checkbox_indicator">
          <ConfirmIcon />
        </div>

        {label && (
          <p className="checkbox_label">
            {label}{" "}
            {link && (
              <a {...link} className="checkbox_link">
                {link.label}
              </a>
            )}
          </p>
        )}
      </label>
    </div>
  );
};

export default Checkbox;
